var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.transaction)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-table',{attrs:{"url":"/api/v1/transaction","filter":[
          {
            name: 'where',
            attributes: {
              id: this.id
            }
          }
        ],"attributes":[
          {
            attribute: 'id',
            name: 'ID',
            type: 'TransactionLinkCell'
          },
          {
            type: 'DateTimeCell',
            attribute: 'paid_at',
            name: 'Datum'
          },
          {
            attribute: 'amount',
            name: 'Einheiten'
          },
          {
            type: 'CurrencyCell',
            attribute: 'price',
            name: 'Preis'
          },
          {
            attribute: 'service_string',
            name: 'Methode'
          },
          {
            attribute: 'service_transaction_id',
            name: 'Buchungs-/Transaktionsnummer'
          },
          {
            type: 'TransactionConfirmCell',
            attribute: 'state',
            name: 'Gebucht?'
          }
        ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Transaktionen")])])],1)]),_vm._v(" "),_c('resource',{attrs:{"resource":"transaction","notification":"Die Informationen wurden gespeichert","original":_vm.transaction[0],"colStyle":"fill","attributes":[
      {
        name: 'information',
        type: 'TextareaSelector',
        rows: 8
      }
    ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Informationen")])])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }